<template>
  <section class="pa-section pa-section-registration">
    <div class="pa-golden-wide-box pa-email-confirmation-infomation">
      <template v-if="pageType === 'loading'">
        <p class="title title-double-line">手続中<span class="mini">-&nbsp;塔経市帝電子異界接続許可情報変更届&nbsp;-</span></p>
        <div class="content content-center">
          <PuffLoadingImage class="waiting-loader" stroke="#BB9A66" />
          <p>しばらくお待ち下さい。</p>
        </div>
      </template>
      <template v-else>
        <p class="title title-double-line">メールアドレス認証<span class="mini">-&nbsp;塔経市帝電子異界接続許可情報確認届&nbsp;-</span></p>
        <div class="content content-center">
          <p>異界舞踏会・アキバトリカルへ御接続いただくには貴方様のメールアドレスの確認が必要で御座います。</p>
          <p>御登録時に御入力いただきましたメールアドレスへ確認メールを送付致しております。</p>
          <p>送付させていただきましたメールに記載されている確認用URLへアクセスしてください。</p>
          <div class="pa-attent-box">
            <p>(※)メールが到着するまで最大１５分程度かかることがあります。</p>
            <p>(※)お使いのクラウドメールサービスによっては迷惑メールボックスに受信される可能性があります。</p>
            <p>(※)万一１５分以上立ってもメールが届かない場合、メールアドレスの入力ミスの可能性があります。その場合はもう一度登録をお試しください。</p>
          </div>
          <div class="pa-resend-button-container">
            <button class="button pa-resend-link" :class="resendButtonClass" :disabled="isDisabledResendButton" @click.prevent="handleResendButton">確認メールを再度送信する</button>
          </div>
          <div class="pa-resend-logout-container">
            <button class="pa-logout-link" :disabled="isDisabledLogoutButton" @click.prevent="handleLogoutButton">ログアウトする</button>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import PuffLoadingImage from '@/views/Registration/Images/puff.svg?inlineN'

import FrontPageMixins from '@/mixins/FrontPageMixins'

export default {
  mixins : [
    FrontPageMixins
  ],

  components : {
    PuffLoadingImage,
  },

  data(){
    return {
      pageType                : 'infomation',

      resendButtonClass       : [],
      isDisabledResendButton  : false,

      isDisabledLogoutButton  : false,
    };
  },

  computed : {
    hasTokens(){
      if(
        (typeof this.$route.params.id !== 'undefined') && 
        (typeof this.$route.query.expires !== 'undefined') && 
        (typeof this.$route.query.signature !== 'undefined')
      ){
        return true;
      }else{
        return false;
      }
    }
  },

  methods : {
    async handleResendButton(){
      this.submitLoading(true);

      await this.UXWaiting(600);

      const results = await this.$store.dispatch({
        type  : 'requests/registration/emailConfirmationResend'
      });

      this.submitLoading(false);

      const validationResult = await this.RESTResultResultValidationGuard(results);

      if(validationResult){
        this.$store.dispatch({
          type        : 'flashMessage/updateFlashMessage',
          hasMessage  : true,
          message     : '&nbsp;ご登録いただきましたメールアドレスに確認メールを再送信致しました。',
          status      : 'primary',
          hasControl  : false,
          autoClose   : 2500
        }, {root:true});
      }
    },
    
    async handleLogoutButton(){
      await this.webApiLogout();
    },

    submitLoading(value = true){
      if(value){
        this.resendButtonClass = ['is-loading'];
        this.isDisabledResendButton = true;
      }else{
        this.resendButtonClass = [];
        this.isDisabledResendButton = false;
      }
    },

    async checkConfirmationTokens(){
      const results = await this.$store.dispatch({
        type      : 'requests/registration/emailConfirmation',
        
        params    : {
          id        : this.$route.params.id,
          expires   : this.$route.query.expires,
          signature : this.$route.query.signature,
        }
      });
      
      const validationResult = this.RESTResultResultValidationGuard(results);

      if(validationResult){
        this.$store.dispatch({
          type        : 'flashMessage/updateFlashMessage',
          hasMessage  : true,
          message     : '&nbsp;メールアドレスの認証が完了しました。',
          status      : 'primary',
          hasControl  : false,
          autoClose   : 2500
        }, {root:true});

        await this.UXWaiting(2500);

        this.$router.push({ name: 'home' });
      }
    }
  },

  async mounted(){
    await this.initializePage({
      'asLoginedView' : true
    });

    if(this.hasTokens){
      this.pageType = 'loading';

      await this.checkConfirmationTokens();
    }else{
      this.pageType = 'infomation';
    }
  }
}
</script>

<style lang="scss">
.pa-section{
  &-registration{
    .pa-email-confirmation-infomation{
      svg.waiting-loader{
        margin:-.5rem 0 .5rem;
        > g{
          stroke-width:3.5;
        }
      }

      .pa-attent-box{
        margin-top:.8rem;
        font-size:.7rem;
        text-align: left;
        color:#847C6E;
        > p{
          margin-bottom:.2rem !important;
        }
      }
    }

    .pa-resend-link{
      background-color: #BBA378;
      border-color:#CEB383;
      border-width: 2.6px;
      border-radius: 7px;
      color:#73654A;
      height:2.38rem;
      padding-top:.37rem;
      padding-left:.6rem;
      padding-right:.6rem;
      font-size:.9rem;
      height:inherit;

      &:active, &:hover, &:focus{
        color:#66583D;
        border-color:#D2C1A2;
      }

      &[disabled]{
        background-color: #AC956C;
        border-color:#D4BF9A;
      }
    }

    .pa-resend-logout-container{
      margin-top:1rem;
      text-align: left;
      padding-bottom:.2rem;

      .pa-logout-link{
        color:#88785A;
        font-size:.6rem;
        letter-spacing:.01rem;

        background-color:transparent;
        border:0;
        text-decoration:underline;
      }
    }
  }
}
</style>